import { useRef, useState } from 'react';
import { Reducer, useReducer } from 'react';
import styles from './styles.scss';
import { rm } from 'utils';
import cn from 'classnames';
import { Button, LoaderButton } from 'components/Button';
import { IconCross } from 'components/Shared/Icon/themes/BGH-RD3/iconCross';
import { IconPlus } from 'components/Shared/Icon';
import Modal from 'components/Shared/Modal';

import { useDidMount } from 'hooks';
import { getUnixTime } from 'date-fns';
import { changeImage } from './upload';

interface OwnProps {
  id?: string;
  imageUrl: string;
  onChange: (id: string, imageUrl: string, token?: string) => void;
  className?: string;
  useZendesk?: boolean;
}

interface OwnState {
  imageUrl: string;
  error: string;
  loading: boolean;
}

export type Action =
  | { type: 'image'; value: string }
  | { type: 'error'; value: string }
  | { type: 'loading' };

const ownReducer: Reducer<OwnState, Action> = (state, action) => {
  switch (action.type) {
    case 'image':
      return { ...state, imageUrl: action.value };
    case 'error':
      return { ...state, error: action.value };
    case 'loading':
      return { ...state, loading: !state.loading };
    default:
      return state;
  }
};

const removeImage = (
  id: string,
  imageUrl: string,
  dispatch: (action: Action) => void,
  onChange: (id: string, imageUrl: string) => void
) => {
  if (imageUrl.length > 0) {
    dispatch({ type: 'image', value: '' });
    onChange(id, '');
  }
};

export const ImageUpload = ({ id, imageUrl, className, onChange, useZendesk }: OwnProps) => {
  const initialState = {
    imageUrl: imageUrl,
    error: '',
    loading: false
  };
  const [idNumber, setIdNumber] = useState('');

  useDidMount(() => {
    if (id) {
      setIdNumber(id);
    } else {
      setIdNumber(getUnixTime(new Date()).toString());
    }
  });

  const [state, dispatch] = useReducer(ownReducer, initialState);
  const inputId = 'fileinput_' + idNumber;
  const ref = useRef<HTMLFormElement>(null);

  return (
    <div className={cn(styles.imageUpload, className)}>
      <Modal
        show={state.error !== ''}
        onClose={() => dispatch({ type: 'error', value: '' })}
        showDefaultButton
      >
        <h1>{rm('Customerpage_Returns_Image_Error_Size_Title')}</h1>
        <p>{state.error}</p>
      </Modal>
      <form encType="multipart/form-data" id={idNumber} ref={ref}>
        <label htmlFor={inputId}>
          {state.loading ? (
            <LoaderButton loading appearance="tertiary" className={styles.loader} />
          ) : state.imageUrl.length > 0 ? (
            <img src={state.imageUrl} />
          ) : (
            <div className={styles.text}>
              <IconPlus />
              <span>{rm('customerpage_returns_image_upload')}</span>
            </div>
          )}
        </label>
        <input
          id={inputId}
          type="file"
          name="attach"
          onChange={e => changeImage({ e, dispatch, ref, onChange, id: idNumber, useZendesk })}
          multiple={false}
          accept=".gif,.jpg,.jpeg,.png"
        />
      </form>
      {state.imageUrl && (
        <Button
          appearance="tertiary"
          className={styles.removeButton}
          onClick={() => removeImage(idNumber, state.imageUrl, dispatch, onChange)}
        >
          <IconCross />
        </Button>
      )}
    </div>
  );
};
